angular.module('aprima-provider-api').factory('Locker',
    ['LockManager', '$log', '_',
        function (LockManager, $log, _) {
            'use strict';

            //objArr can be an object or an array of objects.
            //if it is an array of objects, the first object in the array will be used to get the lock
            //and the lock info will be put on all objects in the array.
            function Locker(objArr, $scope, lockType, objId, objName) {
                if(!objArr || (_.isArray(objArr) && !objArr.length)) {
                    throw new Error('Lockable object must be defined');
                }

                if(!lockType) {
                    throw new Error('LockType must be defined');
                }

                var self = this;
                self.objs = _.isArray(objArr) ? objArr : [objArr];
                self.$scope = $scope;
                self.lockType = lockType;
                var obj = self.objs[0];
                self.objId = objId || obj.Id;
                self.objName = objName;

                if(!self.objId) {
                    throw new Error('Lockable object ID must be defined or must exist on lockable object');
                }

                if($scope) {
                    $scope.$on('locks.updated', function (event, args) {
                        _.forEach(self.objs, function(obj) {
                            var currentLock = obj.LockInfo;

                            if (currentLock && currentLock.InstanceId === args.oldLock.InstanceId) {
                                obj.LockInfo = args.newLock;
                            }
                        });
                    });

                    $scope.$on('$destroy', function () {
                        self.unlock();
                    });
                }
            }

            Locker.prototype = {
                lock: function lock() {
                    var self = this;
                    var objs = self.objs;


                    return LockManager.lock(this.lockType, this.objId)
                        .then(function (lock) {
                            _.forEach(objs, function(obj) {
                                obj.LockInfo = lock;
                                obj.LockInstanceId = lock.InstanceId;
                            });

                            return lock;
                        }, function (response) {
                            $log.info('Unsuccessful in locking ' + self.objName + ': ' + response);
                            _.forEach(objs, function(obj) {
                                obj.LockInfo = response.data;
                            });
                        });
                },
                unlock: function unlock(lockInfo) {
                    var self = this;
                    var objs = self.objs;
                    lockInfo = lockInfo || objs[0].LockInfo;

                    if (!lockInfo) {
                        throw new Error('Cannot unlock ' + self.objName + ' with null or undefined LockInfo.');
                    }

                    return LockManager.unlock(lockInfo.LockType, lockInfo.ObjectId)
                        .then(function (lock) {
                            _.forEach(objs, function(obj) {
                                obj.LockInfo = lock;
                            });
                        }, function (response) {
                            $log.info('Unsuccessful in unlocking ' + self.objName + ': ' + response);
                            _.forEach(objs, function(obj) {
                                obj.LockInfo = response.data;
                            });
                        });
                }
            };

            return Locker;
        }]);